import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'hidden auto',
    padding: '0.5rem'
  }
}))

export default useStyles
